import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { QuoteAcceptance, QuoteViewerQuote } from "src/app/shared/models/DTO/quote-viewer.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import * as uuid from "uuid";
import { AppService } from "./app.service";
import { FocuslinkService } from "./focuslink.service";
import { LocalDataStoreService } from "./local-data-store.service";

@Injectable({
	providedIn: "root",
})
export class QuoteViewerService {
	quote: BehaviorSubject<QuoteViewerQuote> = new BehaviorSubject<QuoteViewerQuote>(undefined);
	quoteAcceptance: BehaviorSubject<QuoteAcceptance> = new BehaviorSubject<QuoteAcceptance>(
		new QuoteAcceptance({
			firstName: "Brandon",
			lastName: "Wermes",
			emailAddress: "brandon2202@gmail.com",
			phoneNumber: `4803991096`,
		})
	);
	quoteSubmitted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	viewerId: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

	constructor(private focuslink: FocuslinkService, public app: AppService, private localDataService: LocalDataStoreService) {}

	async initQuote(quoteId: string) {
		const resp = await this.focuslink.contractFinanceGetQuote(quoteId);
		this.quote.next(new QuoteViewerQuote(resp));
		return this.quote.value;
	}

	async logQuoteView(quoteId: string) {
		let viewerId = await this.localDataService.get("qvid");
		if (!viewerId) {
			viewerId = uuid.v4();
			await this.localDataService.set("qvid", viewerId);
		}

		this.viewerId.next(viewerId);
		const viewBody = {
			quote: quoteId,
			deviceDetail: this.app.deviceService,
			viewerId: viewerId,
		};

		await this.focuslink.contractFinancePostQuoteView(quoteId, viewBody);
	}

	async submitOrder(orderAcceptance: QuoteAcceptance, pdfBlob: any) {
		this.app.loading(true);
		try {
			let viewerId = await this.localDataService.get("qvid");
			if (!viewerId) {
				viewerId = uuid.v4();
				try {
					await this.localDataService.set("qvid", viewerId);
				} catch (error) {}
			}

			orderAcceptance.viewerID = viewerId;
			try {
				const address = await this.focuslink.getIpAddress();
				orderAcceptance.ipAddress = address.ip;
			} catch (error) {
				orderAcceptance.ipAddress = "0.0.0.0";
			}

			orderAcceptance.quoteNumber = this.quote.value.QuoteNumber;
			const body = {
				quote: this.quote.value.Id,
				deviceDetail: this.app.deviceService,
				viewerId: viewerId,
				orderAcceptance: orderAcceptance,
				signedOrder: pdfBlob,
			};

			this.quoteAcceptance.next(orderAcceptance);
			await this.focuslink.contractFinancePostSubmitOrder(this.quote.value.Id, body);
			this.quoteSubmitted.next(true);
			this.app.loading(false);
			this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Thanks 🙏! Your order has been submitted successfully.` });
		} catch (error) {
			this.app.loading(false);
			this.app.msgSvc.add({
				severity: AppMessageSeverity.RED,
				summary: "",
				detail: `There was a problem submitting your order. Please contact your representative.`,
			});
		}
	}

	async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.quoteSubmitted.value === true) {
			return true;
		}
		return false;
	}

	async uploadSignedQuote(blobData) {
		await this.focuslink.contractFinancePostOrderPdf(this.quote.value.Id, {
			quoteId: this.quote.value.Id,
			blob: blobData,
		});
	}
}
